/**
 * ClerkProviderWrapper.jsx — Envoltorio condicional del ClerkProvider.
 *
 * Si VITE_USE_CLERK === 'true' y hay publishableKey, monta <ClerkProvider>.
 * En caso contrario renderiza children directamente para preservar el auth legacy.
 */
import React from 'react'
import { ClerkProvider } from '@clerk/clerk-react'
import {
  isClerkEnabled,
  clerkPublishableKey,
  clerkAppearance,
} from '../config/clerkConfig'

export default function ClerkProviderWrapper({ children }) {
  if (!isClerkEnabled()) {
    return children
  }

  return (
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      appearance={clerkAppearance}
      // Sincroniza el estado de Clerk con react-router (tras login/logout redirige)
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      {children}
    </ClerkProvider>
  )
}
